import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["scrollButton"];

  connect() {
    this.boundCheckScrollPosition = this.checkScrollPosition.bind(this);
    this.element.addEventListener("scroll", this.boundCheckScrollPosition);
    
    // Check position after a brief delay to ensure content is loaded
    setTimeout(() => {
      this.checkScrollPosition();
    }, 100);
    
    // Also check when content changes (useful for dynamically loaded content)
    this.observer = new MutationObserver(() => {
      this.checkScrollPosition();
    });
    
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    });
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.boundCheckScrollPosition);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  checkScrollPosition() {
    // Make sure the scroll button target exists
    if (!this.hasScrollButtonTarget) {
      return;
    }

    const threshold = 100; // px from bottom before showing the button
    const scrollTop = this.element.scrollTop;
    const scrollHeight = this.element.scrollHeight;
    const clientHeight = this.element.clientHeight;
    
    // Check if there's actually content to scroll
    const hasScrollableContent = scrollHeight > clientHeight;
    
    // Check if we're at the bottom
    const atBottom = scrollHeight - scrollTop <= clientHeight + threshold;

    console.log('Scroll check:', {
      scrollTop,
      scrollHeight,
      clientHeight,
      hasScrollableContent,
      atBottom,
      difference: scrollHeight - scrollTop - clientHeight
    });

    if (!hasScrollableContent || atBottom) {
      this.scrollButtonTarget.classList.add("hidden");
    } else {
      this.scrollButtonTarget.classList.remove("hidden");
    }
  }

  scrollToBottom() {
    this.element.scrollTo({
      top: this.element.scrollHeight,
      behavior: 'smooth'
    });
    
    // Hide button after scrolling
    setTimeout(() => {
      this.scrollButtonTarget.classList.add("hidden");
    }, 300); // Small delay to account for smooth scrolling
  }
}